import { TFunction } from 'i18next'
import { CancelPolicy, RefundType } from '@/features/space/space-reservation-types'

export function buildCancelPolicyMessage(policy: CancelPolicy, t: TFunction): string {
  if (policy.freeCancellationDays === 0) {
    return t('Cancel policy until start time')
  }
  return t('Cancel policy days before', { days: policy.freeCancellationDays })
}

export function buildRefundMessage(type: RefundType, amount: number, t: TFunction): string {
  const formatted = amount.toLocaleString()
  switch (type) {
    case 'refund_available':
      return t('Refund message refund available', { amount: formatted })
    case 'no_refund_on_site_payment':
      return t('Refund message no refund on site payment', { amount: formatted })
    case 'no_refund':
      return t('Refund message no refund')
    case 'no_refund_zero':
      return t('Refund message no refund zero')
    case 'refund_available_on_site_settled':
      return t('Refund message refund on site settled', { amount: formatted })
    default:
      return t('Refund contact facility fallback')
  }
}
